import { createApiCall } from 'lib/base';
import { generateEndpoint } from 'utils/urlHelpers';

const GET_STOCK_ORDER_LIST = 'GET_STOCK_ORDER_LIST';

const apiCall = createApiCall(GET_STOCK_ORDER_LIST, (params: {}) => ({
  endpoint: generateEndpoint({
    host: `/api/admin/stock-orders`,
    params,
  }),
  method: 'GET',
}));

export default apiCall;
